import { BoundCoordinates } from './map.model';
import { SearchFilterModel } from './search-filter.model';

export class SearchCriteriaModel {
  CountryCode = '';
  Page = 0;
  PageSize = 50;
  StartAt = 0;
  SearchFilter: number[] = [];
  SortProperty = 0;
  SortDirection = 0;
  RatingMin = 1;
  CustomerRatingMin = 1;
  Bounderies: BoundCoordinates = new BoundCoordinates();
  ShowLocationInformation = true;
  HotelId: number = 0;
  ZoomLevel: number = 0;
  RandomCounter: number = 0;
}
